'use client';

import React, { useCallback, useState } from 'react';
import {
    clearTemplateIdOverride,
    getTemplateIdOverride,
    setTemplateIdOverride,
} from '@/lib/dev/template-id-override.utils';
import { TEMPLATE_ID_OVERRIDE_TEST_IDS } from './TemplateIdOverrideField.consts';
import {
    applyButtonStyle,
    buttonStyle,
    errorStyle,
    hintStyle,
    inputStyle,
    labelStyle,
    rowStyle,
    sectionStyle,
} from './TemplateIdOverrideField.style';

const EMPTY_TEMPLATE_ID_MESSAGE = 'Template ID is required';

const readStoredTemplateId = (): string => {
    const storedTemplateId = getTemplateIdOverride();
    if (storedTemplateId === null) {
        return '';
    }
    return storedTemplateId;
};

export const TemplateIdOverrideField = (): React.ReactElement => {
    const [templateId, setTemplateId] = useState<string>(readStoredTemplateId);
    const [errorMessage, setErrorMessage] = useState('');

    const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>): void => {
        setTemplateId(event.target.value);
        setErrorMessage('');
    }, []);

    const handleApply = useCallback((): void => {
        if (!setTemplateIdOverride(templateId)) {
            setErrorMessage(EMPTY_TEMPLATE_ID_MESSAGE);
            return;
        }
        window.location.reload();
    }, [templateId]);

    const handleClear = useCallback((): void => {
        clearTemplateIdOverride();
        window.location.reload();
    }, []);

    return (
        <div data-testid={TEMPLATE_ID_OVERRIDE_TEST_IDS.root} style={sectionStyle}>
            <span style={labelStyle}>Use templateId</span>
            <div style={rowStyle}>
                <input
                    data-testid={TEMPLATE_ID_OVERRIDE_TEST_IDS.input}
                    type="text"
                    placeholder="Template Studio templateId"
                    value={templateId}
                    style={inputStyle}
                    onChange={handleChange}
                />
                <button
                    data-testid={TEMPLATE_ID_OVERRIDE_TEST_IDS.apply}
                    type="button"
                    style={applyButtonStyle}
                    onClick={handleApply}
                >
                    Apply
                </button>
                <button
                    data-testid={TEMPLATE_ID_OVERRIDE_TEST_IDS.clear}
                    type="button"
                    style={buttonStyle}
                    onClick={handleClear}
                >
                    Clear
                </button>
            </div>
            {errorMessage === '' && (
                <p style={hintStyle}>Empty means the publisher&apos;s active template.</p>
            )}
            {errorMessage !== '' && (
                <p data-testid={TEMPLATE_ID_OVERRIDE_TEST_IDS.error} style={errorStyle}>
                    {errorMessage}
                </p>
            )}
        </div>
    );
};
